export const GET_DATA = "GET_DATA";

export const POST_DATA = "POST_DATA";

export const PUT_DATA = "PUT_DATA";

export const PATCH_DATA = "PATCH_DATA";

export const DELETE_DATA = "DELETE_DATA";
